export default __webpack_public_path__ + "static/media/assunto.d16a476d.svg";